var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "coal-key-indicator" }, [
      _c(
        "svg",
        {
          staticClass: "coal-key-indicator__car",
          attrs: {
            viewBox: "0 0 460 91",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
          },
        },
        [
          _c("path", {
            attrs: {
              d: "M460 90H0",
              stroke: "#C7C7CD",
              "stroke-width": "1.98365",
            },
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              d: "M113.124 24.2578L108.514 18.5697L105.714 16.0603L101.268 12.5471L97.6459 8.36476L91.3886 6.18989L86.1194 6.5245L81.1795 4.18238L74.9223 1.67295H67.6771H65.8658L59.7732 0L48.7408 4.18238H45.6121L37.5436 6.85906L33.0977 11.5434H28.4871L25.1938 16.0603L20.2539 14.722L17.6193 17.2314H13.0087L9.55078 20.41L11.3621 24.2578H113.124Z",
              fill: "#090E12",
            },
          }),
          _vm._v(" "),
          _c("g", { attrs: { opacity: "0.3" } }, [
            _c("g", { attrs: { opacity: "0.3" } }, [
              _c("path", {
                attrs: {
                  opacity: "0.3",
                  d: "M98.4696 16.0604L97.4816 16.8969L97.1523 19.5736H99.1283L99.787 18.7372V16.8969L98.4696 16.0604Z",
                  fill: "white",
                },
              }),
            ]),
          ]),
          _vm._v(" "),
          _c("g", { attrs: { opacity: "0.2" } }, [
            _c("g", { attrs: { opacity: "0.2" } }, [
              _c("path", {
                attrs: {
                  opacity: "0.2",
                  d: "M58.1256 3.34597L57.9609 6.02272H59.9369L60.4309 5.18622V3.34597L59.2783 2.34216L58.1256 3.34597Z",
                  fill: "white",
                },
              }),
            ]),
          ]),
          _vm._v(" "),
          _c("g", { attrs: { opacity: "0.1" } }, [
            _c("g", { attrs: { opacity: "0.1" } }, [
              _c("path", {
                attrs: {
                  opacity: "0.1",
                  d: "M94.0234 9.703L94.6821 14.5546L96.164 14.0528L96.4934 11.0414L95.3407 9.703H94.0234Z",
                  fill: "white",
                },
              }),
            ]),
          ]),
          _vm._v(" "),
          _c("g", { attrs: { opacity: "0.1" } }, [
            _c("g", { attrs: { opacity: "0.1" } }, [
              _c("path", {
                attrs: {
                  opacity: "0.1",
                  d: "M62.5721 8.86658L62.0781 10.8742V15.3913L64.5481 14.5548L65.3714 11.7107L64.2188 8.86658H62.5721Z",
                  fill: "white",
                },
              }),
            ]),
          ]),
          _vm._v(" "),
          _c("g", { attrs: { opacity: "0.3" } }, [
            _c("g", { attrs: { opacity: "0.3" } }, [
              _c("path", {
                attrs: {
                  opacity: "0.3",
                  d: "M54.6682 7.02625L53.5156 9.03385L55.6562 11.376L57.9615 10.7068V9.20115L56.4796 7.02625H54.6682Z",
                  fill: "white",
                },
              }),
            ]),
          ]),
          _vm._v(" "),
          _c("g", { attrs: { opacity: "0.3" } }, [
            _c("g", { attrs: { opacity: "0.3" } }, [
              _c("path", {
                attrs: {
                  opacity: "0.3",
                  d: "M29.8047 14.5546L30.628 17.7332L33.098 15.0565L30.9573 13.049L29.8047 14.5546Z",
                  fill: "white",
                },
              }),
            ]),
          ]),
          _vm._v(" "),
          _c("g", { attrs: { opacity: "0.2" } }, [
            _c("g", { attrs: { opacity: "0.2" } }, [
              _c("path", {
                attrs: {
                  opacity: "0.2",
                  d: "M81.179 5.52075L80.0264 7.19372L80.685 10.205L83.3196 7.52833L81.179 5.52075Z",
                  fill: "white",
                },
              }),
            ]),
          ]),
          _vm._v(" "),
          _c("g", { attrs: { opacity: "0.3" } }, [
            _c("g", { attrs: { opacity: "0.3" } }, [
              _c("path", {
                attrs: {
                  opacity: "0.3",
                  d: "M88.9186 7.86279L86.6133 9.20118V11.0414L87.7659 12.5471L89.9065 10.5395L88.9186 7.86279Z",
                  fill: "white",
                },
              }),
            ]),
          ]),
          _vm._v(" "),
          _c("g", { attrs: { opacity: "0.2" } }, [
            _c("g", { attrs: { opacity: "0.2" } }, [
              _c("path", {
                attrs: {
                  opacity: "0.2",
                  d: "M50.3874 5.52075L48.082 6.8591V8.69938L49.2347 10.205L51.3753 8.19751L50.3874 5.52075Z",
                  fill: "white",
                },
              }),
            ]),
          ]),
          _vm._v(" "),
          _c("g", { attrs: { opacity: "0.3" } }, [
            _c("g", { attrs: { opacity: "0.3" } }, [
              _c("path", {
                attrs: {
                  opacity: "0.3",
                  d: "M67.1826 6.18987L70.6406 10.205L71.7932 7.86284L71.1345 6.18987L71.7932 4.68421L68.9939 3.68042L67.1826 6.18987Z",
                  fill: "white",
                },
              }),
            ]),
          ]),
          _vm._v(" "),
          _c("g", { attrs: { opacity: "0.1" } }, [
            _c("g", { attrs: { opacity: "0.1" } }, [
              _c("path", {
                attrs: {
                  opacity: "0.1",
                  d: "M42.4834 9.87036V13.551L44.7887 14.3875L46.106 12.8818L44.9534 10.8742L42.4834 9.87036Z",
                  fill: "white",
                },
              }),
            ]),
          ]),
          _vm._v(" "),
          _c("path", {
            attrs: {
              d: "M135.023 72.774H26.5098V23.2542H116.91L125.802 46.1738L135.023 72.774Z",
              fill: "#1D1D1B",
            },
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              d: "M127.945 70.0971C127.945 80.1349 119.876 88.3324 109.996 88.3324C100.116 88.3324 92.0479 80.1349 92.0479 70.0971C92.0479 60.0593 100.116 51.8618 109.996 51.8618C119.876 51.8618 127.945 60.0593 127.945 70.0971Z",
              fill: "#2F2E34",
            },
          }),
          _vm._v(" "),
          _c("g", { attrs: { opacity: "0.6" } }, [
            _c("g", { attrs: { opacity: "0.6" } }, [
              _c("g", { attrs: { opacity: "0.6" } }, [
                _c("path", {
                  attrs: {
                    opacity: "0.6",
                    d: "M109.995 54.8732C101.761 54.8732 95.1748 61.565 95.1748 69.9298C95.1748 78.2945 101.761 84.9863 109.995 84.9863C118.228 84.9863 124.814 78.2945 124.814 69.9298C124.814 61.565 118.228 54.8732 109.995 54.8732ZM109.995 82.3096C103.408 82.3096 97.9741 76.7889 97.9741 70.0971C97.9741 63.4052 103.408 57.8845 109.995 57.8845C116.581 57.8845 122.015 63.4052 122.015 70.0971C122.015 76.7889 116.581 82.3096 109.995 82.3096Z",
                    fill: "#2F2E34",
                  },
                }),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("path", {
            attrs: {
              d: "M116.911 70.0971C116.911 73.945 113.782 77.1236 109.995 77.1236C106.208 77.1236 103.079 73.945 103.079 70.0971C103.079 66.2492 106.208 63.0706 109.995 63.0706C113.782 63.0706 116.911 66.2492 116.911 70.0971Z",
              fill: "#878787",
            },
          }),
          _vm._v(" "),
          _c("g", { attrs: { opacity: "0.5" } }, [
            _c("g", { attrs: { opacity: "0.5" } }, [
              _c("g", { attrs: { opacity: "0.5" } }, [
                _c("path", {
                  attrs: {
                    opacity: "0.5",
                    d: "M109.995 63.0706C106.208 63.0706 103.079 66.2492 103.079 70.0971C103.079 73.945 106.208 77.1236 109.995 77.1236C113.782 77.1236 116.911 73.945 116.911 70.0971C116.911 66.2492 113.782 63.0706 109.995 63.0706ZM109.995 76.4544C106.537 76.4544 103.573 73.6103 103.573 69.9298C103.573 66.4165 106.372 63.4052 109.995 63.4052C113.453 63.4052 116.417 66.2492 116.417 69.9298C116.417 73.6103 113.453 76.4544 109.995 76.4544Z",
                    fill: "#878787",
                  },
                }),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("g", { attrs: { opacity: "0.5" } }, [
            _c("g", { attrs: { opacity: "0.5" } }, [
              _c("g", { attrs: { opacity: "0.5" } }, [
                _c("path", {
                  attrs: {
                    opacity: "0.5",
                    d: "M114.441 70.0971C114.441 72.6066 112.465 74.6141 109.995 74.6141C107.525 74.6141 105.549 72.6066 105.549 70.0971C105.549 67.5877 107.525 65.5801 109.995 65.5801C112.465 65.5801 114.441 67.5877 114.441 70.0971Z",
                    fill: "#878787",
                  },
                }),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("path", {
            attrs: {
              d: "M111.971 70.097C111.971 71.2681 110.983 72.1046 109.995 72.1046C108.843 72.1046 108.02 71.1008 108.02 70.097C108.02 68.926 109.007 68.0895 109.995 68.0895C111.148 67.9222 111.971 68.926 111.971 70.097Z",
              fill: "#878787",
            },
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              d: "M114.441 53.1999H108.184L106.537 51.0251H112.794L114.441 53.1999Z",
              fill: "#2F2E34",
            },
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              d: "M105.548 53.2002L100.114 56.3788L97.6445 55.375L103.078 52.1964L105.548 53.2002Z",
              fill: "#2F2E34",
            },
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              d: "M97.8111 57.717L94.6825 63.2378L92.0479 63.5724L95.1765 58.0516L97.8111 57.717Z",
              fill: "#2F2E34",
            },
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              d: "M93.3642 65.4128V71.9374L91.2236 73.6103V67.2531L93.3642 65.4128Z",
              fill: "#2F2E34",
            },
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              d: "M93.3639 74.4468L96.4926 79.9676L95.5046 82.6444L92.376 77.1235L93.3639 74.4468Z",
              fill: "#2F2E34",
            },
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              d: "M97.8105 82.3097L103.244 85.4883L103.574 88.3324L98.1399 85.1538L97.8105 82.3097Z",
              fill: "#2F2E34",
            },
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              d: "M105.384 86.994H111.806L113.452 89.169H107.195L105.384 86.994Z",
              fill: "#2F2E34",
            },
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              d: "M114.441 86.994L119.875 83.8153L122.345 84.8191L116.911 87.9977L114.441 86.994Z",
              fill: "#2F2E34",
            },
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              d: "M122.016 82.477L125.309 76.9563L127.943 76.4543L124.815 82.1424L122.016 82.477Z",
              fill: "#2F2E34",
            },
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              d: "M126.627 74.614V68.2568L128.768 66.5839V72.9411L126.627 74.614Z",
              fill: "#2F2E34",
            },
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              d: "M126.627 65.58L123.498 60.0592L124.486 57.5498L127.615 63.0705L126.627 65.58Z",
              fill: "#2F2E34",
            },
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              d: "M122.181 57.7172L116.747 54.5385L116.418 51.8618L121.852 55.0404L122.181 57.7172Z",
              fill: "#2F2E34",
            },
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              d: "M57.9611 70.0971C57.9611 80.1349 49.8926 88.3324 40.0128 88.3324C30.133 88.3324 22.0645 80.1349 22.0645 70.0971C22.0645 60.0593 30.133 51.8618 40.0128 51.8618C49.8926 51.8618 57.9611 60.0593 57.9611 70.0971Z",
              fill: "#2F2E34",
            },
          }),
          _vm._v(" "),
          _c("g", { attrs: { opacity: "0.6" } }, [
            _c("g", { attrs: { opacity: "0.6" } }, [
              _c("g", { attrs: { opacity: "0.6" } }, [
                _c("path", {
                  attrs: {
                    opacity: "0.6",
                    d: "M40.0131 54.8732C31.7799 54.8732 25.1934 61.565 25.1934 69.9298C25.1934 78.2945 31.7799 84.9863 40.0131 84.9863C48.2463 84.9863 54.8329 78.2945 54.8329 69.9298C54.8329 61.565 48.2463 54.8732 40.0131 54.8732ZM40.0131 82.3096C33.4266 82.3096 27.9927 76.7889 27.9927 70.0971C27.9927 63.4052 33.4266 57.8845 40.0131 57.8845C46.5997 57.8845 52.0336 63.4052 52.0336 70.0971C52.0336 76.7889 46.5997 82.3096 40.0131 82.3096Z",
                    fill: "#2F2E34",
                  },
                }),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("path", {
            attrs: {
              d: "M46.9284 70.0971C46.9284 73.945 43.7998 77.1236 40.0125 77.1236C36.2253 77.1236 33.0967 73.945 33.0967 70.0971C33.0967 66.2492 36.2253 63.0706 40.0125 63.0706C43.7998 63.0706 46.9284 66.2492 46.9284 70.0971Z",
              fill: "#878787",
            },
          }),
          _vm._v(" "),
          _c("g", { attrs: { opacity: "0.5" } }, [
            _c("g", { attrs: { opacity: "0.5" } }, [
              _c("g", { attrs: { opacity: "0.5" } }, [
                _c("path", {
                  attrs: {
                    opacity: "0.5",
                    d: "M40.0125 63.0706C36.2253 63.0706 33.0967 66.2492 33.0967 70.0971C33.0967 73.945 36.2253 77.1236 40.0125 77.1236C43.7998 77.1236 46.9284 73.945 46.9284 70.0971C46.9284 66.2492 43.7998 63.0706 40.0125 63.0706ZM40.0125 76.4544C36.5546 76.4544 33.5907 73.6103 33.5907 69.9298C33.5907 66.4165 36.3899 63.4052 40.0125 63.4052C43.4705 63.4052 46.4344 66.2492 46.4344 69.9298C46.4344 73.6103 43.4705 76.4544 40.0125 76.4544Z",
                    fill: "#878787",
                  },
                }),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("g", { attrs: { opacity: "0.5" } }, [
            _c("g", { attrs: { opacity: "0.5" } }, [
              _c("g", { attrs: { opacity: "0.5" } }, [
                _c("path", {
                  attrs: {
                    opacity: "0.5",
                    d: "M44.4592 70.0971C44.4592 72.6066 42.4832 74.6141 40.0133 74.6141C37.5433 74.6141 35.5674 72.6066 35.5674 70.0971C35.5674 67.5877 37.5433 65.5801 40.0133 65.5801C42.4832 65.5801 44.4592 67.5877 44.4592 70.0971Z",
                    fill: "#878787",
                  },
                }),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("path", {
            attrs: {
              d: "M41.99 70.097C41.99 71.2681 41.002 72.1046 40.014 72.1046C38.8614 72.1046 38.0381 71.1008 38.0381 70.097C38.0381 68.926 39.026 68.0895 40.014 68.0895C41.1667 67.9222 41.99 68.926 41.99 70.097Z",
              fill: "#878787",
            },
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              d: "M44.4586 53.1999H38.2013L36.5547 51.0251H42.8119L44.4586 53.1999Z",
              fill: "#2F2E34",
            },
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              d: "M35.567 53.2002L30.133 56.3788L27.6631 55.375L33.097 52.1964L35.567 53.2002Z",
              fill: "#2F2E34",
            },
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              d: "M27.8277 57.717L24.6991 63.2378L22.0645 63.5724L25.1931 58.0516L27.8277 57.717Z",
              fill: "#2F2E34",
            },
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              d: "M23.3818 65.4128V71.9374L21.2412 73.6103V67.2531L23.3818 65.4128Z",
              fill: "#2F2E34",
            },
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              d: "M23.3815 74.4468L26.5101 79.9676L25.5222 82.6444L22.3936 77.1235L23.3815 74.4468Z",
              fill: "#2F2E34",
            },
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              d: "M27.8281 82.3097L33.262 85.4883L33.5914 88.3324L28.1575 85.1538L27.8281 82.3097Z",
              fill: "#2F2E34",
            },
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              d: "M35.5674 86.994H41.8246L43.4712 89.169H37.214L35.5674 86.994Z",
              fill: "#2F2E34",
            },
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              d: "M44.459 86.994L49.8929 83.8153L52.3628 84.8191L46.9289 87.9977L44.459 86.994Z",
              fill: "#2F2E34",
            },
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              d: "M52.1982 82.477L55.3269 76.9563L57.9615 76.4543L54.8329 82.1424L52.1982 82.477Z",
              fill: "#2F2E34",
            },
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              d: "M56.6436 74.614V68.2568L58.7841 66.5839V72.9411L56.6436 74.614Z",
              fill: "#2F2E34",
            },
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              d: "M56.6442 65.58L53.5156 60.0592L54.5036 57.5498L57.6322 63.0705L56.6442 65.58Z",
              fill: "#2F2E34",
            },
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              d: "M52.1978 57.7172L46.7639 54.5385L46.4346 51.8618L51.8685 55.0404L52.1978 57.7172Z",
              fill: "#2F2E34",
            },
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              d: "M123.332 39.1473H105.384V23.2542H118.392L123.332 39.1473Z",
              fill: "#2F2E34",
            },
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              d: "M115.765 35.1341V28.2711H119.501L121.513 35.1341H115.765Z",
              fill: "white",
              stroke: "#2F2E34",
            },
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              d: "M113.782 27.7711H109.501V35.6341H113.782V27.7711Z",
              fill: "white",
            },
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              d: "M128.766 43.1621C128.272 43.1621 127.778 42.8275 127.778 42.1583V28.6074C127.778 28.1055 128.108 27.6036 128.766 27.6036C129.26 27.6036 129.754 27.9382 129.754 28.6074V42.1583C129.754 42.6602 129.26 43.1621 128.766 43.1621Z",
              fill: "#2F2E34",
            },
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              d: "M107.196 14.7219L103.738 17.9006H10.8678L0 30.1132L82.9905 63.5726L99.9509 30.2805L130.908 23.7559V19.9081V17.9006V14.7219H107.196Z",
              fill: "#2F2E34",
            },
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              d: "M3.45801 31.6189L12.3498 24.4252H96.987L78.5447 61.7323L3.45801 31.6189Z",
              fill: "#494949",
            },
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              d: "M126.626 37.307H102.421V45.5045H126.626V37.307Z",
              fill: "#2F2E34",
            },
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              d: "M131.73 40.6531H121.191V45.17H131.73V40.6531Z",
              fill: "#2F2E34",
            },
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              d: "M99.1278 35.2993C98.7984 35.2993 98.6338 35.4666 98.6338 35.8012V40.151V41.322V45.1699H99.1278V41.322H102.915V45.1699H103.409V41.322H107.196V45.1699H107.69V41.322H111.478V45.1699H111.972V41.322H115.759V45.1699H116.253V41.322H120.04V45.1699H120.534V41.322H124.321V45.1699H124.815V41.322H128.603V45.1699H129.097V41.322H132.884V45.1699H133.378V41.322V40.151V35.8012C133.378 35.4666 133.213 35.2993 132.884 35.2993H99.1278ZM99.1278 40.151V36.3031C99.1278 36.1358 99.2924 35.9685 99.4571 35.9685H103.08V40.151H99.1278ZM103.244 35.9685H107.032V40.151H103.244V35.9685ZM107.526 35.9685H111.313V40.151H107.526V35.9685ZM111.807 35.9685H115.594V40.151H111.807V35.9685ZM116.088 35.9685H119.875V40.151H116.088V35.9685ZM120.369 35.9685H124.157V40.151H120.369V35.9685ZM124.486 35.9685H128.273V40.151H124.486V35.9685ZM132.555 40.151H128.767V35.9685H132.39C132.555 35.9685 132.719 36.1358 132.719 36.3031V40.151H132.555Z",
              fill: "#B4B4B4",
            },
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              d: "M93.0349 57.8843H89.9062L96.6574 45.337C96.9868 44.6678 97.6454 44.3333 98.3041 44.3333H132.883C135.189 44.3333 137 46.1735 137 48.5157V78.2945H132.389L126.462 51.527C125.968 49.3521 123.992 47.8464 121.851 47.8464H101.433C99.7861 47.8464 98.1394 48.8503 97.3161 50.1886L93.0349 57.8843Z",
              fill: "#2F2E34",
            },
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              d: "M91.2233 19.9082L90.7293 20.7447L88.0947 26.0981L70.6403 60.3938L66.1943 58.5536L82.6607 26.0981L85.1307 21.5812L85.954 19.9082H91.2233Z",
              fill: "#2F2E34",
            },
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              d: "M75.9103 19.9082L75.4162 20.5774L72.7816 26.0981L57.9619 55.2075L53.6807 53.5346L67.5124 26.0981L69.8177 21.4139L70.641 19.9082H75.9103Z",
              fill: "#2F2E34",
            },
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              d: "M60.9253 19.9082L45.4469 50.1889L41.001 48.3486L55.656 19.9082H60.9253Z",
              fill: "#2F2E34",
            },
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              d: "M46.1048 19.9082L45.1168 21.5812L42.8115 26.0981L33.0963 45.1699L28.6504 43.497L37.5422 26.0981L39.3535 22.4176L40.8355 19.9082H46.1048Z",
              fill: "#2F2E34",
            },
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              d: "M31.6147 18.068L20.4176 40.151L15.9717 38.3107L26.0162 18.5699L31.6147 18.068Z",
              fill: "#2F2E34",
            },
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              d: "M78.7094 76.4543H64.8776C63.0663 76.4543 61.749 74.9487 61.749 73.2757V67.5876C61.749 65.7473 63.231 64.4089 64.8776 64.4089H78.7094C80.5207 64.4089 81.838 65.9146 81.838 67.5876V73.2757C81.838 75.116 80.356 76.4543 78.7094 76.4543Z",
              fill: "#2F2E34",
            },
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              d: "M66.1939 63.907H64.7119V76.9561H66.1939V63.907Z",
              fill: "#2C2E33",
            },
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              d: "M78.8726 63.907H77.3906V76.9561H78.8726V63.907Z",
              fill: "#2C2E33",
            },
          }),
        ]
      ),
      _vm._v(" "),
      _c(
        "svg",
        {
          staticClass: "coal-key-indicator__digits",
          attrs: {
            viewBox: "0 0 420 152",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
          },
        },
        [_vm._t("default")],
        2
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }